import {Component, OnInit, SimpleChanges, TemplateRef, ViewChild, ViewEncapsulation} from '@angular/core';
import {FormBuilder, NgModel, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';

import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
// import {validate as isValidEmail} from 'email-validator';
// import {AsYouType, parsePhoneNumber} from 'libphonenumber-js';
import {CoreConfigService} from '@core/services/config.service';
import {AuthenticationService} from "../../../auth/service";
import {Router} from "@angular/router";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-auth-register-v1',
  templateUrl: './auth-register-v1.component.html',
  styleUrls: ['./auth-register-v1.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthRegisterV1Component implements OnInit {
  @ViewChild('registrationProblemModal') registrationProblemModal!: TemplateRef<any>;

  // Public
  public userExist : boolean = false;
  public validationErrorMessage = '';
  public coreConfig: any;
  public passwordTextType: boolean;
  public registerForm: UntypedFormGroup;
  public submitted = false;
  email: string = '';
  password: string = '';
  username: string = '';
  showPassword = false;
  name: string = '';
  surname: string = '';
  phone: string = '';
  acceptPrivacyPolicy: boolean;
  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   * @param {FormBuilder} _formBuilder
   */
  constructor(private modalService: NgbModal,
              private _coreConfigService: CoreConfigService,
              private _formBuilder: FormBuilder,
              private _authenticationService: AuthenticationService,
              private router: Router) {
    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.registerForm.controls;
  }

  /**
   * Toggle password
   */
  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  /**
   * On Submit
   */
  onSubmit() {
    this.registerForm.get('username').valueChanges.subscribe(value => {
      this.ifUserExists(value);
    });
    this.submitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    } else {
      const formData = this.registerForm.value;
      this._authenticationService.checkUsernames(formData.username).then((response) => {
        if (response) {
          if (response === "Username not available") {
            this.validationErrorMessage = "siamo spiacenti, il nome utente inserito non è disponibile, utilizza un altro nome utente.";
            this.openProblemModal(this.registrationProblemModal);
            return;
          } else {
            this._authenticationService.signUp(
              formData.name,
              formData.surname,
              formData.email,
              formData.phoneNumber,
              formData.username,
              formData.password,
            ).then((response) => {
              console.log("Response:", response);
              if (response) {
                if (response === "User created") {
                  console.log("User created successfully!");
                  this._authenticationService.signin(formData.username, formData.password)
                    .catch((error) => {
                      console.error(error);
                    });
                  return new Promise<boolean>((resolve, reject) => {
                    this._authenticationService.isAuthenticated()
                      .then((response: any) => {
                        if (response.status === 404) {
                          console.log('User not authenticated');
                          this.router.navigate(['/authentication/login']);
                          resolve(false);
                        } else if (response.status === 401) {
                          console.log('Business not authenticated');
                          this.router.navigate(['/authentication/business-selection']);
                          resolve(false);
                        } else {
                          console.log('User authenticated');
                          resolve(true);
                        }
                      })
                      .catch((error: any) => {
                        resolve(false);
                      });
                  });
                } else {
                  this.validationErrorMessage = "Errore durante la creazione dell'utente.";
                  console.log("Unexpected response:", response);
                  this.openProblemModal(this.registrationProblemModal);
                }
              } else {
                this.validationErrorMessage = "Errore durante la creazione dell'utente.";
                console.log("Response is undefined or null");
                this.openProblemModal(this.registrationProblemModal);
              }
            }).catch((error) => {
              this.validationErrorMessage = "Errore durante la creazione dell'utente.";
              console.log("Error:", error);
              this.openProblemModal(this.registrationProblemModal);
            });
          }
        } else {
          this.validationErrorMessage = "Errore durante la creazione dell'utente.";
          console.log("Response is undefined or null");
          this.openProblemModal(this.registrationProblemModal);
        }
      }
      ).catch((error) => {
        console.log(error);
      });
    }
  }

  ifUserExists(username: string) {
    this.registerForm.get('username').markAsTouched();
    if (username.length > 0) {
      console.log("Username:", username);
      //convert to lowercase
      username = username.toLowerCase();
      this._authenticationService.checkUsernames(username).then((response) => {
        if (response) {
          console.log("Response:", response);
          if (response === 'Username not available') {
            this.registerForm.get('username').markAsTouched();
            this.userExist = true;
            console.log("User exists", this.userExist)  ;
          } else {
            this.userExist = false;
          }
        } else {
          this.userExist = false;
        }
      }).catch((error) => {
        console.log(error);
      });
    } else {
      this.userExist = false;
    }
  }


  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.registerForm = this._formBuilder.group({
      name: ['', Validators.required],
      surname: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: ['', Validators.required],
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
    this.registerForm.get('username').valueChanges.subscribe(value => {
      this.ifUserExists(value);
    });
    this.registerForm.get('username').markAsTouched();

    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
  }

  openProblemModal(modalWrong: TemplateRef<any>): NgbModalRef {
    return this.modalService.open(modalWrong, {
      centered: true,
      size: 'sm',
      windowClass: 'modal modal-primary'
    });
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  isEmailValid(email: NgModel): boolean {
    // return isValidEmail(email.value);
    return true
  }

  isPhoneNumberValid(phone: string): boolean {
    try {
      // const phoneNumber = parsePhoneNumber(phone, 'IT');
      // return phoneNumber && phoneNumber.isValid();
      return true
    } catch (error) {
      return false;
    }
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
